import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronLeft: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentCOlor"
                fillRule="evenodd"
                d="M7.518 11.971a1.496 1.496 0 0 1 .433-1.06l5.972-5.972a1.5 1.5 0 0 1 2.12 2.12l-4.941 4.912 4.747 4.927a1.493 1.493 0 1 1-2.149 2.06l-5.763-5.972a1.493 1.493 0 0 1-.419-1.015z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const ChevronLeftOffset: IconOffset = {
    vertical: 18,
    horizontal: 31,
};

export default React.memo(ChevronLeft);
